
import moment from "moment";
import nysService from "../../services/nysService";
import { recordError } from "../../utils/logService";
import { nysIntakeMessage } from "../../utils/apiConstants";

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

export const getClosingDate = async () => {
    const currentDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    const defaultMessage = nysIntakeMessage['No-intake'];
    let msg;
    let nysApplication = {
        message: defaultMessage.body,
        subject: defaultMessage.subject,
    };

    try {
        const response = await nysService.getClosingDate(currentDate);

        if (response && (response.status === 200 || response.status === 201)) {
            const { data } = response;

            const intake = data?.details;
            if (intake){
                let _showApply = false;
                const midNightClosing = moment(intake.endDate).endOf("day");
                const openingDate = moment(intake.startDate).startOf("day");
                let effectiveDate = openingDate;

                // If nys programme is open, thus current data in between open and close
                // of the programme, then allow registration for NYS
                if (currentDate > openingDate._i && currentDate > midNightClosing._i) {
                    effectiveDate = midNightClosing;
                }
                else if (currentDate >= openingDate._i && currentDate <= midNightClosing._i) {
                    _showApply = true;
                    effectiveDate = midNightClosing;
                }
                else {
                    effectiveDate = openingDate;
                }
                const message = nysIntakeMessage[data.messageHint];
                const body = message.body + moment(effectiveDate).format("dddd, Do MMMM YYYY, [at] HH:mm")

                nysApplication = {
                    ...nysApplication,
                    open: _showApply,
                    closingDate: midNightClosing,
                    openingDate: openingDate,
                    closure: moment(midNightClosing).format("dddd, Do MMMM YYYY, [at] HH:mm"),
                    message: body,
                    subject: message.subject,
                }
            }
        }
    } catch (error) {
        //We need to find a way to handle the below exception
        recordError(error);
        if (error && error?.response?.status === 404) {
            return;
        }
        msg = util.parseMessage(Messages.CLOSING_DATE, "Closing date");
        openNotification("Closing date", msg, Notify.ERROR);
        recordError(error);
    }

    localStorage.setItem("nys-application", nysApplication);
    return nysApplication;
};
